import { type DietaryPreferencesTypes } from '../setup/types';

// ─────────────────────────────────────────────────────────────────────────────

export function checkIfHasSelectedPreferences(preferences: DietaryPreferencesTypes) {
  return Object.values(preferences).some(Boolean);
}
